import React ,{Component } from 'react';
import CertRequest from '../views/certrequest';
import { physicianActions, patientActions,certrequestActions,certificationReferenceActions,certificationTypeActions,certificationTypeGroupActions } from "../../actions";
import { connect } from 'react-redux';
import { objConstants} from '../../constants/obj.constants'
import { history } from '../../helpers';
import { withRouter } from "react-router-dom";

class CertRequestContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isNextStep:false
         }
        this.submit = this.submit.bind(this);
        this.handleCreateCertRef = this.handleCreateCertRef.bind(this);
    }
    
    submit(event) {

        event.preventDefault();
        let data = this.refs.child.getData();
        const { dispatch } = this.props;

        this.setState({
            isNextStep:true
        })
        //console.log('data',data);
        if(data.Id)
        {
            //dispatch(patientActions.edit(data,data.Id));

        }else{


            console.log(data);

            dispatch(certrequestActions.add(data));

        }
        
     
    }

    handleCreateCertRef(model) {

        const { dispatch } = this.props;

        //console.log('*****CertRef',model);

        dispatch(certificationReferenceActions.add(model));

        dispatch(certificationReferenceActions.gets()); 
    }

    componentDidMount(){
       

       const {patientId}=this.props.match.params;

       console.log('Props',this.props);

       const { dispatch } = this.props;   

        if (patientId) {

            let id = patientId;
             
            dispatch(patientActions.get(id));     
        
        } 
      
        dispatch(certificationTypeGroupActions.gets()); 

        dispatch(certificationTypeActions.gets()); 
 

        dispatch(certificationReferenceActions.gets()); 
        dispatch(physicianActions.gets()); 
       
    }

    render() { 

        const { type,obj,items } = this.props;
        const {isNextStep}=this.state;
        console.log('Items',items);
        if(type==objConstants.ADD_SUCCESS && isNextStep)
        {
            console.log('Added successfully');
          //  history.push('/certrequest/payment/'+obj.Id)
          history.push('/showcertrequestsimple/'+obj.Id)
        }
      
     
        return ( 
            <CertRequest CreateCertRefHandler={this.handleCreateCertRef} submitHandler={this.submit} model={this.props.obj} certReferenceList={(items!=null && items.CertReferences!=null)?items.CertReferences:null} physicianList={(items!=null && items.physicianList!=null)?items.physicianList:null} certTypeGroupList={(items!=null && items.cerTypeGroups!=null)?items.cerTypeGroups:null} certTypeList={(items!=null && items.certTypes!=null)?items.certTypes:null} {...this.props}  ref="child" />
         );
    }
}

function mapStateToProps(state,ownProps) {
    const { loading,type,item,items,error } = state.objs;
    
   //console.log('STATE',state)
    //const { type } = state;
    return {
        loading,
        type,
        obj:item,
        items,
        error
      
        
    };
} 

export default withRouter(connect(mapStateToProps)(CertRequestContainer));